// Copiar como constants.js (está en .gitignore).
//
// En Vite, estas constantes pasarán a variables de entorno, p. ej.:
//   VITE_API_BASE, VITE_STORAGE_PREFIX, etc.

const STORAGE_PREFIX = 'IR-MICROSITIOS'

const constants = {
    appName : 'Ingenia Rest',
    api : {
        base : 'https://ir.ingeniabit.com'
    },
    storage : {
        prefix: STORAGE_PREFIX,
    },
    hooks : {
        sat  : {
            regimenes : 'regimenes',
            usosCfdi : 'usosCfdi',
            formasPago : 'formasPago'
        }
    },
    themeDefaults : {
        themeMode: 'dark',
        themeDirection: 'ltr',
        themeContrast: 'default',
        themeLayout: 'vertical',
        themeColorPresets: 'red',
        themeStretch: false,
    },
    gmapsKey : 'AIzaSyBUpg_ALxS3rY4boGpCMlif1DPoK76K1UA',
    defaultGps : {
        lat : 19.4356, lng : -99.1439
    },
    openPayMerchantId : 'mwi7gud5mkzzqmkpqafb',
    openpayPk : 'pk_efc3afb68a484c95849788daa4d399c8',
    openPaySandbox : 1
}

const storageKey = (key) => `${constants.storage.prefix}_${key}`

export { constants, storageKey }

// PROD : https://ir.ingeniabit.com
// DEV : http://ingenia-rest.des:8080
// DEV SERVER: https://dev-ir-nube.ingeniabit.com
